import { render, staticRenderFns } from "./MatchingQuestionDraggableOption.vue?vue&type=template&id=e5794f36&scoped=true"
import script from "./MatchingQuestionDraggableOption.vue?vue&type=script&lang=js"
export * from "./MatchingQuestionDraggableOption.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=e5794f36&prod&scoped=true&lang=css&external"
import style1 from "./MatchingQuestionDraggableOption.vue?vue&type=style&index=1&id=e5794f36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5794f36",
  null
  
)

export default component.exports